import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { RootState } from 'client/js/redux/types/redux.types';
import { deepCopy } from '../../../../../../shared/utils';
import { selectCostFileTemplateMapping } from '../CostFileTemplateCreator.selectors';
import {
  BRANCH_FIELD_ALTERNATIVE_VALUES,
  BRANCH_FIELD_AUTOMAP_ORDER,
  OPTIONAL_BRANCH_FIELD_OPTIONS,
  REQUIRED_BRANCH_FIELD_OPTIONS,
} from '../constants/costFileTemplateBranchFieldOptions';
import type { CostFileTemplateField } from '../types/ReducerTypes';

export const AUTO_MAP_COST_FILE_TEMPLATE = 'AUTO_MAP_COST_FILE_TEMPLATE' as const;

export const autoMapCostFileTemplate = () => (dispatch: any, getState: () => RootState) => {
  const options = deepCopy([...REQUIRED_BRANCH_FIELD_OPTIONS, ...OPTIONAL_BRANCH_FIELD_OPTIONS]);
  const findOptionByLabel = (label) => options.find((option) => option.label === label);
  const includesSubstrings = (str, substrings) => substrings.every((substring) => str.toLowerCase().includes(substring));

  const state = getState();
  const mapping = deepCopy(selectCostFileTemplateMapping(state));

  // try exact match on branch value and alternatives
  mapping.forEach((field) => {
    if (field.invalidCharacters) {
      return;
    }

    const exact = options.findIndex((option) => field.sourceKey.toLowerCase() === option.value.toLowerCase());
    if (exact !== -1) {
      field.branchKeyOption = options[exact];
      options.splice(exact, 1);
      return;
    }

    Object.entries(BRANCH_FIELD_ALTERNATIVE_VALUES).find(([branchField, alternatives]) => {
      if (alternatives.includes(field.sourceKey.toLowerCase())) {
        field.branchKeyOption = findOptionByLabel(branchField);
        return true;
      }
    });
  });

  // try regex match on branch value and alternatives
  BRANCH_FIELD_AUTOMAP_ORDER.forEach((branchField) => {
    const substrings = branchField.split(/[^a-z]/);

    const foundFieldIndex = mapping.findIndex(
      (field) => !field.branchKeyOption && includesSubstrings(field.sourceKey, substrings)
    );
    if (foundFieldIndex !== -1) {
      mapping[foundFieldIndex].branchKeyOption = findOptionByLabel(branchField);
      return;
    }

    const alternatives = BRANCH_FIELD_ALTERNATIVE_VALUES[branchField] || [];
    alternatives.find((alternative) => {
      const substrings = alternative.split(/[^a-z]/);

      const foundFieldIndex = mapping.findIndex(
        (field) => !field.branchKeyOption && includesSubstrings(field.sourceKey, substrings)
      );
      if (foundFieldIndex !== -1) {
        mapping[foundFieldIndex].branchKeyOption = findOptionByLabel(branchField);
        return true;
      }
    });
  });

  return dispatch({
    type: AUTO_MAP_COST_FILE_TEMPLATE,
    data: mapping,
  });
};

export type AutoMapCostFileTemplateAction = DataAction<typeof AUTO_MAP_COST_FILE_TEMPLATE, CostFileTemplateField[]>;
